<!--suppress ALL -->
<template>
  <g-field :label="hasSlotDefault || skipLabel ? '' : $t('label.tahun')"
           class="select-tahun-ajaran" :is-horizontal="hasSlotDefault">
    <label v-if="hasSlotDefault" class="label">{{$t('label.tahun')}}</label>
    <g-select :value="tahunAjaran" :placeholder="`Pilih tahun`"
              :disabled="disabled" @change="onChange" v-bind="$attrs">
      <option v-for="th in computedTahunAjarans" :key="th" :value="th">{{th}}</option>
    </g-select>
    <slot></slot>
  </g-field>
</template>

<script lang="ts">
	import {Component, Prop, Vue} from 'annotation';
	import {tahunAjarans, tahunAjaranPsb, tahunAjaranSekolah} from '../../util/PluralVariabels';

	@Component
	export default class SelectTahunAjaran extends Vue {

		@Prop({type: String})
		public tahunAjaran: string;

		@Prop({type: Boolean, default: false})
		public disabled: boolean;

    @Prop({type: Boolean, default: false})
    public skipLabel: boolean;

    @Prop({type: String, default: 'pondok'})
    public type: 'pondok' | 'sekolah' | 'psb';

    @Prop({type: Boolean, default: false})
    public isPsb: boolean;

    public get computedTahunAjarans() {
      if (this.isPsb || this.type === 'psb') return tahunAjaranPsb;
      if (this.type === 'sekolah') return tahunAjaranSekolah;
      return tahunAjarans;
    }

		public onChange(val) {
			this.$emit('update:tahunAjaran', val);
			this.$emit('tahun-ajar-selected', val);
		}

		public get hasSlotDefault() {
			return this.$scopedSlots.default || this.$slots.default;
		}
	}
</script>

<style lang="scss">
  .select-tahun-ajaran {
    .select, select {
      min-width: 200px;
      width: 100%;
    }
    &.is-horizontal {
      .field-body {
        align-items: center;
        .field {
          &:first-child {
            width: 150px;
          }
          flex: none;
        }
      }
    }
  }
</style>
